import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import { cartesianPlaneLogic } from './cartesian_plane.logic';
import { CartesianPlaneActivityView } from './CartesianPlaneViews';

export const cartesianPlanePlugin: ActivityPlugin<'cartesian_plane'> = {
  ...cartesianPlaneLogic,
  displayName: GAME_MODE_CATALOG.cartesian_plane.displayName,
  icon: GAME_MODE_CATALOG.cartesian_plane.icon,
  HostView: CartesianPlaneActivityView,
  StudentView: CartesianPlaneActivityView,
  ProjectorView: CartesianPlaneActivityView,
};

export { demoCartesianPlanePayload } from './cartesian_plane.logic';
